import {
  INIT_ALERT,
  FLUSH_ALERT,
  CHECK_SCREEN_WIDTH,
  LOADING_MESSAGE,
} from './types';

export default {
  initAlert({ commit }, data) {
    commit(INIT_ALERT, data);
  },
  flushAlert({ commit }) {
    commit(FLUSH_ALERT);
  },
  checkScreenWidth({ commit }, size) {
    commit(CHECK_SCREEN_WIDTH, size);
  },
  setLoadingMessage({ commit }, message) {
    commit(LOADING_MESSAGE, message);
  }
};
